import { render, staticRenderFns } from "./debt-management-advisor-tabular.vue?vue&type=template&id=7bdd8f8a"
import script from "./debt-management-advisor-tabular.vue?vue&type=script&lang=js"
export * from "./debt-management-advisor-tabular.vue?vue&type=script&lang=js"
import style0 from "../../../assets/styles/amortization-breakdown-table.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports